import { ApiClient } from '../api-client';

import {
  TFinalSpeechToTextResponse,
  IGoogleSpeechToTextRecognitionOptions,
} from './types';
import { googleSpeechToTextUrl } from './urls';

/**
 * This provides the API client methods for all tenant related services like.
 * Such fetching tenant config, tenant specific data etc.
 */
export class ExternalApisClient extends ApiClient {
  private static classInstance?: ExternalApisClient;

  private constructor() {
    super({});
  }

  /**
   * Applying the dreaded singleton pattern here to reuse the axios instance.
   */
  public static getClientInstance = () => {
    if (!this.classInstance) {
      this.classInstance = new ExternalApisClient();
    }

    return this.classInstance;
  };

  /**
   * Api call to upload Bid book.
   * - Currently, hosted within the API routes at
   * - `apps/device-assessment/src/pages/api/google/speech-to-text.ts`
   */
  public processSpeechToTextWithGoogle = async (
    payload: IGoogleSpeechToTextRecognitionOptions
  ) => {
    const body = { base64Audio: payload.base64Audio };

    const response = await this.post<TFinalSpeechToTextResponse>(
      googleSpeechToTextUrl(),
      body,
      {
        baseURL: process.env.NEXT_PUBLIC_BASE_HOST_URL || '',
      }
    );

    if (!response.success) throw response;

    return response.data;
  };
}

/**
 * This creates a new instance of the class. is th base Axios API client Class
 * wrapper for all external APIs related services, like Google Speech to Text.
 */
export const EXTERNAL_API = ExternalApisClient.getClientInstance();
